module.exports = __webpack_public_path__ + "static/img/nuomi.d59d6a33.png";